import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_PM_PROJECT_PLAN_BY_STATUS_API } from "./apiRoutes";

const getProjectPlanByStatus = async (projectId: string, status: string): Promise<any> => {
  return await axiosAuth.get(DASHBOARD_PM_PROJECT_PLAN_BY_STATUS_API(projectId, status));
};

const useGetProjectPlanByStatus = (
  projectId: string,
  status: string,
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["project-plan-by-status", projectId, status],
    queryFn: () => getProjectPlanByStatus(projectId, status),
    select: (data: any) => data?.data?.data?.[0],


    enabled: !!projectId && !!status,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetProjectPlanByStatus;
